import type { App } from "vue";
import type { Router } from "vue-router";
import * as Sentry from "@sentry/vue";
import { getEnvironment } from "@/shared/helper/environment.helper";
import { useSelectedCustomerStore } from "@/shared/stores/SelectedCustomerStore";

export function initSentry(app: App, router?: Router) {
  if (import.meta.env.DEV || import.meta.env.VITE_CI == "true") return;

  // eslint-disable-next-line no-console
  console.debug("Initializing Sentry...");

  const environment = getEnvironment();

  const selectedCustomerStore = useSelectedCustomerStore();

  Sentry.init({
    app,
    dsn: "https://75036c2db4b24d8b88145515f3cba9e0@exceptions.zweitagapps.com/13",
    tracePropagationTargets: ["localhost", /^\//],
    integrations: router
      ? [
          Sentry.browserTracingIntegration({
            router,
          }),
          Sentry.vueIntegration({
            tracingOptions: {
              trackComponents: true,
            },
          }),
        ]
      : [
          Sentry.vueIntegration({
            tracingOptions: {
              trackComponents: true,
            },
          }),
        ],
    environment,
    release: import.meta.env.VITE_APP_REVISION?.toString(),
    // See: https://docs.sentry.io/platforms/javascript/configuration/sampling/#sampling-transaction-events
    tracesSampleRate: 0.2,
    beforeSend: (event) => {
      return {
        ...event,
        extra: {
          ...event.extra,
          customerId: selectedCustomerStore.selectedCustomer?.id || "",
        },
      };
    },
  });
}
